export default `<div role="none" class="mod mod-header">
    <!--Super Market Store Demo Header-->
    <div role="none" class="row visible-md visible-lg">
        <div role="none" class="col-xs-12 header-padding">
            <img height="93" class="img-responsive center-block"
                src="//cdn.cpnscdn.com/static.coupons.com/Sites/riq/demo/images/parker_header.png" />
        </div>
        <div role="none" class="col-xs-12 header-bottom">

        </div>
    </div>
    <div role="none" class="row visible-xs visible-sm mobile-nav">
        <div role="none" class="col-xs-8">
            <img height="54" class="pull-left logo"
                src="//cdn.cpnscdn.com/static.coupons.com/Sites/riq/demo/images/parker_header_mobile.png" />
        </div>
    </div>
</div>`;
